/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BehindWorkOrdersPageDto,
  ChangeControlControllerListBehindWorkOrdersParams,
  ChangeControlControllerListRunItemsParams,
  ChangeControlControllerListRunsParams,
  ChangeControlControllerPreviewBillOfOperationsReleaseParams,
  ChangeControlRunItemResponseDto,
  ChangeControlRunResponseDto,
  StartBillOfOperationsReleaseDto,
  StartOperationReleaseDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Stages a release of bill_of_operations_id onto the listed work orders. target_version is computed server-side: the materialiser captures current rules and overrides into a new Bill of Operations version (or reuses the current one if state is unchanged). Inserts a change_control_run + change_control_run_items, then enqueues a BullMQ run-init job which fans out per-work-order child jobs. Empty work_order_ids is accepted as a capture-only release: the version bump is recorded as a closed audit-trail run with total=0 and status=completed. Returns the run header — poll GET /runs/{run_id} for progress.
 * @summary Start a Bill of Operations release
 */
export type changeControlControllerStartBillOfOperationsReleaseResponse201 = {
  data: ChangeControlRunResponseDto
  status: 201
}

export type changeControlControllerStartBillOfOperationsReleaseResponse400 = {
  data: void
  status: 400
}

export type changeControlControllerStartBillOfOperationsReleaseResponse401 = {
  data: void
  status: 401
}
    
export type changeControlControllerStartBillOfOperationsReleaseResponseSuccess = (changeControlControllerStartBillOfOperationsReleaseResponse201) & {
  headers: Headers;
};
export type changeControlControllerStartBillOfOperationsReleaseResponseError = (changeControlControllerStartBillOfOperationsReleaseResponse400 | changeControlControllerStartBillOfOperationsReleaseResponse401) & {
  headers: Headers;
};

export type changeControlControllerStartBillOfOperationsReleaseResponse = (changeControlControllerStartBillOfOperationsReleaseResponseSuccess | changeControlControllerStartBillOfOperationsReleaseResponseError)

export const getChangeControlControllerStartBillOfOperationsReleaseUrl = () => {


  

  return `/change-control/runs/bill-of-operations-release`
}

export const changeControlControllerStartBillOfOperationsRelease = async (startBillOfOperationsReleaseDto: StartBillOfOperationsReleaseDto, options?: RequestInit): Promise<changeControlControllerStartBillOfOperationsReleaseResponse> => {
  
  return customFetch<changeControlControllerStartBillOfOperationsReleaseResponse>(getChangeControlControllerStartBillOfOperationsReleaseUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      startBillOfOperationsReleaseDto,)
  }
);}




export const getChangeControlControllerStartBillOfOperationsReleaseMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeControlControllerStartBillOfOperationsRelease>>, TError,{data: StartBillOfOperationsReleaseDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changeControlControllerStartBillOfOperationsRelease>>, TError,{data: StartBillOfOperationsReleaseDto}, TContext> => {

const mutationKey = ['changeControlControllerStartBillOfOperationsRelease'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeControlControllerStartBillOfOperationsRelease>>, {data: StartBillOfOperationsReleaseDto}> = (props) => {
          const {data} = props ?? {};

          return  changeControlControllerStartBillOfOperationsRelease(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeControlControllerStartBillOfOperationsReleaseMutationResult = NonNullable<Awaited<ReturnType<typeof changeControlControllerStartBillOfOperationsRelease>>>
    export type ChangeControlControllerStartBillOfOperationsReleaseMutationBody = StartBillOfOperationsReleaseDto
    export type ChangeControlControllerStartBillOfOperationsReleaseMutationError = void

    /**
 * @summary Start a Bill of Operations release
 */
export const useChangeControlControllerStartBillOfOperationsRelease = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeControlControllerStartBillOfOperationsRelease>>, TError,{data: StartBillOfOperationsReleaseDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeControlControllerStartBillOfOperationsRelease>>,
        TError,
        {data: StartBillOfOperationsReleaseDto},
        TContext
      > => {

      const mutationOptions = getChangeControlControllerStartBillOfOperationsReleaseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Stages a release of an operation version onto the listed work orders. The producer resolves each work order to the latest Bill of Operations version that includes (operation_id, target_version). Work orders whose current Bill of Operations doesn't contain the target operation version are skipped.
 * @summary Start an operation release
 */
export type changeControlControllerStartOperationReleaseResponse201 = {
  data: ChangeControlRunResponseDto
  status: 201
}

export type changeControlControllerStartOperationReleaseResponse400 = {
  data: void
  status: 400
}

export type changeControlControllerStartOperationReleaseResponse401 = {
  data: void
  status: 401
}
    
export type changeControlControllerStartOperationReleaseResponseSuccess = (changeControlControllerStartOperationReleaseResponse201) & {
  headers: Headers;
};
export type changeControlControllerStartOperationReleaseResponseError = (changeControlControllerStartOperationReleaseResponse400 | changeControlControllerStartOperationReleaseResponse401) & {
  headers: Headers;
};

export type changeControlControllerStartOperationReleaseResponse = (changeControlControllerStartOperationReleaseResponseSuccess | changeControlControllerStartOperationReleaseResponseError)

export const getChangeControlControllerStartOperationReleaseUrl = () => {


  

  return `/change-control/runs/operation-release`
}

export const changeControlControllerStartOperationRelease = async (startOperationReleaseDto: StartOperationReleaseDto, options?: RequestInit): Promise<changeControlControllerStartOperationReleaseResponse> => {
  
  return customFetch<changeControlControllerStartOperationReleaseResponse>(getChangeControlControllerStartOperationReleaseUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      startOperationReleaseDto,)
  }
);}




export const getChangeControlControllerStartOperationReleaseMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeControlControllerStartOperationRelease>>, TError,{data: StartOperationReleaseDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changeControlControllerStartOperationRelease>>, TError,{data: StartOperationReleaseDto}, TContext> => {

const mutationKey = ['changeControlControllerStartOperationRelease'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeControlControllerStartOperationRelease>>, {data: StartOperationReleaseDto}> = (props) => {
          const {data} = props ?? {};

          return  changeControlControllerStartOperationRelease(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeControlControllerStartOperationReleaseMutationResult = NonNullable<Awaited<ReturnType<typeof changeControlControllerStartOperationRelease>>>
    export type ChangeControlControllerStartOperationReleaseMutationBody = StartOperationReleaseDto
    export type ChangeControlControllerStartOperationReleaseMutationError = void

    /**
 * @summary Start an operation release
 */
export const useChangeControlControllerStartOperationRelease = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeControlControllerStartOperationRelease>>, TError,{data: StartOperationReleaseDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeControlControllerStartOperationRelease>>,
        TError,
        {data: StartOperationReleaseDto},
        TContext
      > => {

      const mutationOptions = getChangeControlControllerStartOperationReleaseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns runs for the partner, most-recent first. Optionally filter by status.
 * @summary List change control runs
 */
export type changeControlControllerListRunsResponse200 = {
  data: ChangeControlRunResponseDto[]
  status: 200
}
    
export type changeControlControllerListRunsResponseSuccess = (changeControlControllerListRunsResponse200) & {
  headers: Headers;
};
;

export type changeControlControllerListRunsResponse = (changeControlControllerListRunsResponseSuccess)

export const getChangeControlControllerListRunsUrl = (params: ChangeControlControllerListRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/change-control/runs?${stringifiedParams}` : `/change-control/runs`
}

export const changeControlControllerListRuns = async (params: ChangeControlControllerListRunsParams, options?: RequestInit): Promise<changeControlControllerListRunsResponse> => {
  
  return customFetch<changeControlControllerListRunsResponse>(getChangeControlControllerListRunsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChangeControlControllerListRunsQueryKey = (params?: ChangeControlControllerListRunsParams,) => {
    return [
    `/change-control/runs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getChangeControlControllerListRunsQueryOptions = <TData = Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError = unknown>(params: ChangeControlControllerListRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChangeControlControllerListRunsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof changeControlControllerListRuns>>> = ({ signal }) => changeControlControllerListRuns(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChangeControlControllerListRunsQueryResult = NonNullable<Awaited<ReturnType<typeof changeControlControllerListRuns>>>
export type ChangeControlControllerListRunsQueryError = unknown


export function useChangeControlControllerListRuns<TData = Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError = unknown>(
 params: ChangeControlControllerListRunsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof changeControlControllerListRuns>>,
          TError,
          Awaited<ReturnType<typeof changeControlControllerListRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerListRuns<TData = Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError = unknown>(
 params: ChangeControlControllerListRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof changeControlControllerListRuns>>,
          TError,
          Awaited<ReturnType<typeof changeControlControllerListRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerListRuns<TData = Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError = unknown>(
 params: ChangeControlControllerListRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List change control runs
 */

export function useChangeControlControllerListRuns<TData = Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError = unknown>(
 params: ChangeControlControllerListRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChangeControlControllerListRunsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List change control runs
 */
export const prefetchChangeControlControllerListRunsQuery = async <TData = Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError = unknown>(
 queryClient: QueryClient, params: ChangeControlControllerListRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getChangeControlControllerListRunsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getChangeControlControllerListRunsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError = unknown>(params: ChangeControlControllerListRunsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChangeControlControllerListRunsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof changeControlControllerListRuns>>> = ({ signal }) => changeControlControllerListRuns(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChangeControlControllerListRunsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof changeControlControllerListRuns>>>
export type ChangeControlControllerListRunsSuspenseQueryError = unknown


export function useChangeControlControllerListRunsSuspense<TData = Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError = unknown>(
 params: ChangeControlControllerListRunsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerListRunsSuspense<TData = Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError = unknown>(
 params: ChangeControlControllerListRunsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerListRunsSuspense<TData = Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError = unknown>(
 params: ChangeControlControllerListRunsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List change control runs
 */

export function useChangeControlControllerListRunsSuspense<TData = Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError = unknown>(
 params: ChangeControlControllerListRunsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChangeControlControllerListRunsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns a paginated list of the partner's active (scheduled / redrafting / in_progress), non-archived work orders that are pinned to a Bill of Operations version lower than the current released version of their Bill of Operations. Replaces the quality app pattern of fetching the whole partner production planner and filtering client-side. Group rows by bill_of_operations_id to offer per-Bill-of-Operations releases.
 * @summary List work orders behind their current Bill of Operations version
 */
export type changeControlControllerListBehindWorkOrdersResponse200 = {
  data: BehindWorkOrdersPageDto
  status: 200
}

export type changeControlControllerListBehindWorkOrdersResponse400 = {
  data: void
  status: 400
}

export type changeControlControllerListBehindWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type changeControlControllerListBehindWorkOrdersResponse403 = {
  data: void
  status: 403
}
    
export type changeControlControllerListBehindWorkOrdersResponseSuccess = (changeControlControllerListBehindWorkOrdersResponse200) & {
  headers: Headers;
};
export type changeControlControllerListBehindWorkOrdersResponseError = (changeControlControllerListBehindWorkOrdersResponse400 | changeControlControllerListBehindWorkOrdersResponse401 | changeControlControllerListBehindWorkOrdersResponse403) & {
  headers: Headers;
};

export type changeControlControllerListBehindWorkOrdersResponse = (changeControlControllerListBehindWorkOrdersResponseSuccess | changeControlControllerListBehindWorkOrdersResponseError)

export const getChangeControlControllerListBehindWorkOrdersUrl = (params: ChangeControlControllerListBehindWorkOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/change-control/behind-work-orders?${stringifiedParams}` : `/change-control/behind-work-orders`
}

export const changeControlControllerListBehindWorkOrders = async (params: ChangeControlControllerListBehindWorkOrdersParams, options?: RequestInit): Promise<changeControlControllerListBehindWorkOrdersResponse> => {
  
  return customFetch<changeControlControllerListBehindWorkOrdersResponse>(getChangeControlControllerListBehindWorkOrdersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChangeControlControllerListBehindWorkOrdersQueryKey = (params?: ChangeControlControllerListBehindWorkOrdersParams,) => {
    return [
    `/change-control/behind-work-orders`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getChangeControlControllerListBehindWorkOrdersQueryOptions = <TData = Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError = void>(params: ChangeControlControllerListBehindWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChangeControlControllerListBehindWorkOrdersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>> = ({ signal }) => changeControlControllerListBehindWorkOrders(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChangeControlControllerListBehindWorkOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>>
export type ChangeControlControllerListBehindWorkOrdersQueryError = void


export function useChangeControlControllerListBehindWorkOrders<TData = Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError = void>(
 params: ChangeControlControllerListBehindWorkOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerListBehindWorkOrders<TData = Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError = void>(
 params: ChangeControlControllerListBehindWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerListBehindWorkOrders<TData = Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError = void>(
 params: ChangeControlControllerListBehindWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List work orders behind their current Bill of Operations version
 */

export function useChangeControlControllerListBehindWorkOrders<TData = Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError = void>(
 params: ChangeControlControllerListBehindWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChangeControlControllerListBehindWorkOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List work orders behind their current Bill of Operations version
 */
export const prefetchChangeControlControllerListBehindWorkOrdersQuery = async <TData = Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError = void>(
 queryClient: QueryClient, params: ChangeControlControllerListBehindWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getChangeControlControllerListBehindWorkOrdersQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getChangeControlControllerListBehindWorkOrdersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError = void>(params: ChangeControlControllerListBehindWorkOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChangeControlControllerListBehindWorkOrdersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>> = ({ signal }) => changeControlControllerListBehindWorkOrders(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChangeControlControllerListBehindWorkOrdersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>>
export type ChangeControlControllerListBehindWorkOrdersSuspenseQueryError = void


export function useChangeControlControllerListBehindWorkOrdersSuspense<TData = Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError = void>(
 params: ChangeControlControllerListBehindWorkOrdersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerListBehindWorkOrdersSuspense<TData = Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError = void>(
 params: ChangeControlControllerListBehindWorkOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerListBehindWorkOrdersSuspense<TData = Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError = void>(
 params: ChangeControlControllerListBehindWorkOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List work orders behind their current Bill of Operations version
 */

export function useChangeControlControllerListBehindWorkOrdersSuspense<TData = Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError = void>(
 params: ChangeControlControllerListBehindWorkOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListBehindWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChangeControlControllerListBehindWorkOrdersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns the run header including counters. Poll while status is queued/processing.
 * @summary Get a change control run
 */
export type changeControlControllerGetRunResponse200 = {
  data: ChangeControlRunResponseDto
  status: 200
}

export type changeControlControllerGetRunResponse404 = {
  data: void
  status: 404
}
    
export type changeControlControllerGetRunResponseSuccess = (changeControlControllerGetRunResponse200) & {
  headers: Headers;
};
export type changeControlControllerGetRunResponseError = (changeControlControllerGetRunResponse404) & {
  headers: Headers;
};

export type changeControlControllerGetRunResponse = (changeControlControllerGetRunResponseSuccess | changeControlControllerGetRunResponseError)

export const getChangeControlControllerGetRunUrl = (runId: string,) => {


  

  return `/change-control/runs/${runId}`
}

export const changeControlControllerGetRun = async (runId: string, options?: RequestInit): Promise<changeControlControllerGetRunResponse> => {
  
  return customFetch<changeControlControllerGetRunResponse>(getChangeControlControllerGetRunUrl(runId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChangeControlControllerGetRunQueryKey = (runId?: string,) => {
    return [
    `/change-control/runs/${runId}`
    ] as const;
    }

    
export const getChangeControlControllerGetRunQueryOptions = <TData = Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError = void>(runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChangeControlControllerGetRunQueryKey(runId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof changeControlControllerGetRun>>> = ({ signal }) => changeControlControllerGetRun(runId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(runId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChangeControlControllerGetRunQueryResult = NonNullable<Awaited<ReturnType<typeof changeControlControllerGetRun>>>
export type ChangeControlControllerGetRunQueryError = void


export function useChangeControlControllerGetRun<TData = Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError = void>(
 runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof changeControlControllerGetRun>>,
          TError,
          Awaited<ReturnType<typeof changeControlControllerGetRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerGetRun<TData = Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError = void>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof changeControlControllerGetRun>>,
          TError,
          Awaited<ReturnType<typeof changeControlControllerGetRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerGetRun<TData = Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError = void>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get a change control run
 */

export function useChangeControlControllerGetRun<TData = Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError = void>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChangeControlControllerGetRunQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get a change control run
 */
export const prefetchChangeControlControllerGetRunQuery = async <TData = Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError = void>(
 queryClient: QueryClient, runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getChangeControlControllerGetRunQueryOptions(runId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getChangeControlControllerGetRunSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError = void>(runId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChangeControlControllerGetRunQueryKey(runId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof changeControlControllerGetRun>>> = ({ signal }) => changeControlControllerGetRun(runId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChangeControlControllerGetRunSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof changeControlControllerGetRun>>>
export type ChangeControlControllerGetRunSuspenseQueryError = void


export function useChangeControlControllerGetRunSuspense<TData = Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError = void>(
 runId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerGetRunSuspense<TData = Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError = void>(
 runId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerGetRunSuspense<TData = Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError = void>(
 runId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get a change control run
 */

export function useChangeControlControllerGetRunSuspense<TData = Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError = void>(
 runId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerGetRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChangeControlControllerGetRunSuspenseQueryOptions(runId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns per-work-order item rows for a run. Optionally filter by status to surface failed items for the Resume action.
 * @summary List items for a run
 */
export type changeControlControllerListRunItemsResponse200 = {
  data: ChangeControlRunItemResponseDto[]
  status: 200
}
    
export type changeControlControllerListRunItemsResponseSuccess = (changeControlControllerListRunItemsResponse200) & {
  headers: Headers;
};
;

export type changeControlControllerListRunItemsResponse = (changeControlControllerListRunItemsResponseSuccess)

export const getChangeControlControllerListRunItemsUrl = (runId: string,
    params?: ChangeControlControllerListRunItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/change-control/runs/${runId}/items?${stringifiedParams}` : `/change-control/runs/${runId}/items`
}

export const changeControlControllerListRunItems = async (runId: string,
    params?: ChangeControlControllerListRunItemsParams, options?: RequestInit): Promise<changeControlControllerListRunItemsResponse> => {
  
  return customFetch<changeControlControllerListRunItemsResponse>(getChangeControlControllerListRunItemsUrl(runId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChangeControlControllerListRunItemsQueryKey = (runId?: string,
    params?: ChangeControlControllerListRunItemsParams,) => {
    return [
    `/change-control/runs/${runId}/items`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getChangeControlControllerListRunItemsQueryOptions = <TData = Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError = unknown>(runId: string,
    params?: ChangeControlControllerListRunItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChangeControlControllerListRunItemsQueryKey(runId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof changeControlControllerListRunItems>>> = ({ signal }) => changeControlControllerListRunItems(runId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(runId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChangeControlControllerListRunItemsQueryResult = NonNullable<Awaited<ReturnType<typeof changeControlControllerListRunItems>>>
export type ChangeControlControllerListRunItemsQueryError = unknown


export function useChangeControlControllerListRunItems<TData = Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError = unknown>(
 runId: string,
    params: undefined |  ChangeControlControllerListRunItemsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof changeControlControllerListRunItems>>,
          TError,
          Awaited<ReturnType<typeof changeControlControllerListRunItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerListRunItems<TData = Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError = unknown>(
 runId: string,
    params?: ChangeControlControllerListRunItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof changeControlControllerListRunItems>>,
          TError,
          Awaited<ReturnType<typeof changeControlControllerListRunItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerListRunItems<TData = Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError = unknown>(
 runId: string,
    params?: ChangeControlControllerListRunItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List items for a run
 */

export function useChangeControlControllerListRunItems<TData = Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError = unknown>(
 runId: string,
    params?: ChangeControlControllerListRunItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChangeControlControllerListRunItemsQueryOptions(runId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List items for a run
 */
export const prefetchChangeControlControllerListRunItemsQuery = async <TData = Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError = unknown>(
 queryClient: QueryClient, runId: string,
    params?: ChangeControlControllerListRunItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getChangeControlControllerListRunItemsQueryOptions(runId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getChangeControlControllerListRunItemsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError = unknown>(runId: string,
    params?: ChangeControlControllerListRunItemsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChangeControlControllerListRunItemsQueryKey(runId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof changeControlControllerListRunItems>>> = ({ signal }) => changeControlControllerListRunItems(runId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChangeControlControllerListRunItemsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof changeControlControllerListRunItems>>>
export type ChangeControlControllerListRunItemsSuspenseQueryError = unknown


export function useChangeControlControllerListRunItemsSuspense<TData = Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError = unknown>(
 runId: string,
    params: undefined |  ChangeControlControllerListRunItemsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerListRunItemsSuspense<TData = Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError = unknown>(
 runId: string,
    params?: ChangeControlControllerListRunItemsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerListRunItemsSuspense<TData = Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError = unknown>(
 runId: string,
    params?: ChangeControlControllerListRunItemsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List items for a run
 */

export function useChangeControlControllerListRunItemsSuspense<TData = Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError = unknown>(
 runId: string,
    params?: ChangeControlControllerListRunItemsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerListRunItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChangeControlControllerListRunItemsSuspenseQueryOptions(runId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Re-enqueues per-work-order child jobs for any items still in queued or processing state. Idempotent.
 * @summary Resume a partially failed or interrupted run
 */
export type changeControlControllerResumeRunResponse202 = {
  data: void
  status: 202
}

export type changeControlControllerResumeRunResponse404 = {
  data: void
  status: 404
}
    
export type changeControlControllerResumeRunResponseSuccess = (changeControlControllerResumeRunResponse202) & {
  headers: Headers;
};
export type changeControlControllerResumeRunResponseError = (changeControlControllerResumeRunResponse404) & {
  headers: Headers;
};

export type changeControlControllerResumeRunResponse = (changeControlControllerResumeRunResponseSuccess | changeControlControllerResumeRunResponseError)

export const getChangeControlControllerResumeRunUrl = (runId: string,) => {


  

  return `/change-control/runs/${runId}/resume`
}

export const changeControlControllerResumeRun = async (runId: string, options?: RequestInit): Promise<changeControlControllerResumeRunResponse> => {
  
  return customFetch<changeControlControllerResumeRunResponse>(getChangeControlControllerResumeRunUrl(runId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getChangeControlControllerResumeRunMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeControlControllerResumeRun>>, TError,{runId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changeControlControllerResumeRun>>, TError,{runId: string}, TContext> => {

const mutationKey = ['changeControlControllerResumeRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeControlControllerResumeRun>>, {runId: string}> = (props) => {
          const {runId} = props ?? {};

          return  changeControlControllerResumeRun(runId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeControlControllerResumeRunMutationResult = NonNullable<Awaited<ReturnType<typeof changeControlControllerResumeRun>>>
    
    export type ChangeControlControllerResumeRunMutationError = void

    /**
 * @summary Resume a partially failed or interrupted run
 */
export const useChangeControlControllerResumeRun = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeControlControllerResumeRun>>, TError,{runId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeControlControllerResumeRun>>,
        TError,
        {runId: string},
        TContext
      > => {

      const mutationOptions = getChangeControlControllerResumeRunMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns the set of non-archived, non-complete work orders on the listed Bill of Operations. The wizard shows these as the work orders that will be rolled to whatever version the release resolves to (current version, or a new version if matrix overrides are pending).
 * @summary Preview work orders affected by a Bill of Operations release
 */
export type changeControlControllerPreviewBillOfOperationsReleaseResponse200 = {
  data: void
  status: 200
}

export type changeControlControllerPreviewBillOfOperationsReleaseResponse403 = {
  data: void
  status: 403
}

export type changeControlControllerPreviewBillOfOperationsReleaseResponse404 = {
  data: void
  status: 404
}
    
export type changeControlControllerPreviewBillOfOperationsReleaseResponseSuccess = (changeControlControllerPreviewBillOfOperationsReleaseResponse200) & {
  headers: Headers;
};
export type changeControlControllerPreviewBillOfOperationsReleaseResponseError = (changeControlControllerPreviewBillOfOperationsReleaseResponse403 | changeControlControllerPreviewBillOfOperationsReleaseResponse404) & {
  headers: Headers;
};

export type changeControlControllerPreviewBillOfOperationsReleaseResponse = (changeControlControllerPreviewBillOfOperationsReleaseResponseSuccess | changeControlControllerPreviewBillOfOperationsReleaseResponseError)

export const getChangeControlControllerPreviewBillOfOperationsReleaseUrl = (params: ChangeControlControllerPreviewBillOfOperationsReleaseParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/change-control/preview/bill-of-operations?${stringifiedParams}` : `/change-control/preview/bill-of-operations`
}

export const changeControlControllerPreviewBillOfOperationsRelease = async (params: ChangeControlControllerPreviewBillOfOperationsReleaseParams, options?: RequestInit): Promise<changeControlControllerPreviewBillOfOperationsReleaseResponse> => {
  
  return customFetch<changeControlControllerPreviewBillOfOperationsReleaseResponse>(getChangeControlControllerPreviewBillOfOperationsReleaseUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChangeControlControllerPreviewBillOfOperationsReleaseQueryKey = (params?: ChangeControlControllerPreviewBillOfOperationsReleaseParams,) => {
    return [
    `/change-control/preview/bill-of-operations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getChangeControlControllerPreviewBillOfOperationsReleaseQueryOptions = <TData = Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError = void>(params: ChangeControlControllerPreviewBillOfOperationsReleaseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChangeControlControllerPreviewBillOfOperationsReleaseQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>> = ({ signal }) => changeControlControllerPreviewBillOfOperationsRelease(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChangeControlControllerPreviewBillOfOperationsReleaseQueryResult = NonNullable<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>>
export type ChangeControlControllerPreviewBillOfOperationsReleaseQueryError = void


export function useChangeControlControllerPreviewBillOfOperationsRelease<TData = Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError = void>(
 params: ChangeControlControllerPreviewBillOfOperationsReleaseParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>,
          TError,
          Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerPreviewBillOfOperationsRelease<TData = Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError = void>(
 params: ChangeControlControllerPreviewBillOfOperationsReleaseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>,
          TError,
          Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerPreviewBillOfOperationsRelease<TData = Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError = void>(
 params: ChangeControlControllerPreviewBillOfOperationsReleaseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Preview work orders affected by a Bill of Operations release
 */

export function useChangeControlControllerPreviewBillOfOperationsRelease<TData = Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError = void>(
 params: ChangeControlControllerPreviewBillOfOperationsReleaseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChangeControlControllerPreviewBillOfOperationsReleaseQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Preview work orders affected by a Bill of Operations release
 */
export const prefetchChangeControlControllerPreviewBillOfOperationsReleaseQuery = async <TData = Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError = void>(
 queryClient: QueryClient, params: ChangeControlControllerPreviewBillOfOperationsReleaseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getChangeControlControllerPreviewBillOfOperationsReleaseQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getChangeControlControllerPreviewBillOfOperationsReleaseSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError = void>(params: ChangeControlControllerPreviewBillOfOperationsReleaseParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChangeControlControllerPreviewBillOfOperationsReleaseQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>> = ({ signal }) => changeControlControllerPreviewBillOfOperationsRelease(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChangeControlControllerPreviewBillOfOperationsReleaseSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>>
export type ChangeControlControllerPreviewBillOfOperationsReleaseSuspenseQueryError = void


export function useChangeControlControllerPreviewBillOfOperationsReleaseSuspense<TData = Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError = void>(
 params: ChangeControlControllerPreviewBillOfOperationsReleaseParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerPreviewBillOfOperationsReleaseSuspense<TData = Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError = void>(
 params: ChangeControlControllerPreviewBillOfOperationsReleaseParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChangeControlControllerPreviewBillOfOperationsReleaseSuspense<TData = Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError = void>(
 params: ChangeControlControllerPreviewBillOfOperationsReleaseParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Preview work orders affected by a Bill of Operations release
 */

export function useChangeControlControllerPreviewBillOfOperationsReleaseSuspense<TData = Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError = void>(
 params: ChangeControlControllerPreviewBillOfOperationsReleaseParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof changeControlControllerPreviewBillOfOperationsRelease>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChangeControlControllerPreviewBillOfOperationsReleaseSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




